import { getDateRange } from "./datetime"

export const generateFilter = (filters) =>
  filters
    .filter((f) => f.value !== "All")
    .map((f) => {
      if (
        f.id === "createdAt" ||
        f.id === "CreatedAt" ||
        f.id === "LastUpdatedAt"
      ) {
        const interval = getDateRange(f.value)
        return {
          id: f.id,
          value: [interval.start.toISO(), interval.end.toISO()].join(","),
        }
      }
      if (f.id === "LogType") {
        const extractedLogType = getLogTypeBasedOnValue(f.value)
        return {
          id: f.id,
          value: extractedLogType,
        }
      }
      return { id: f.id, value: f.value.toLowerCase().trim() }
    })
    .reduce((acc, f) => {
      acc[f.id] = f.value
      return acc
    }, {})

export const getLogTypeBasedOnValue = (value) => {
  if (value === "Invalid XHTML") {
    return "ERROR_INVALID_XHTML"
  } else if (value === "Non Spine/Herniation Info Missing") {
    return "INFO_NON_CSP_LSP_REPORT"
  } else {
    return ""
  }
}

export const setTokensToLocalStorage = (accessToken, refreshToken) => {
  localStorage.setItem("accessToken", JSON.stringify(accessToken))
  localStorage.setItem("refreshToken", JSON.stringify(refreshToken))
}

export const removeTokensFromLocalStorage = () => {
  localStorage.removeItem("accessToken")
  localStorage.removeItem("refreshToken")
}

export const getAccessToken = () => {
  const accessToken = localStorage.getItem("accessToken")
  return accessToken ? JSON.parse(accessToken) : null
}

export const getRefreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken")
  return refreshToken ? JSON.parse(refreshToken) : null
}

export const setUserToLocalStorage = (user) => {
  localStorage.setItem("user", JSON.stringify(user))
}

export const getUserFromLocalStorage = () => {
  const user = localStorage.getItem("user")
  return user ? JSON.parse(user) : null
}

export const updatedUserFromLocalStorage = (updatedUser) => {
  localStorage.setItem("user", JSON.stringify(updatedUser))
}

export const removeUserFromLocalStorage = () => {
  localStorage.removeItem("user")
}

export const setOtpVerification = (value) => {
  localStorage.setItem("otpVerified", JSON.stringify(value))
}

export const isOtpVerified = () => {
  const isOtpVerified = localStorage.getItem("otpVerified")
  return isOtpVerified ? JSON.parse(isOtpVerified) : false
}

export const removeOtpVerificationFromLocalStorage = () => {
  localStorage.removeItem("otpVerified")
}

export const stringToBoolean = (str) => {
  if (typeof str === "string") {
    return str === "true"
  }

  return str
}

export const saveRememberMeToken = (token) => {
  localStorage.setItem("rememberMeToken", token)
}

export const getRememberMeToken = () => localStorage.getItem("rememberMeToken")
